
/**
 * @private
 * @param {int} n The number to pad
 * @param {int} width Size to pad to
 */
const pad0 = (n, width) => {
  const z = '0';
  const nStr = `${n}`;
  const numZ = width - nStr.length;
  return n.length >= width ? nStr : new Array(numZ + 1).join(z) + nStr;
};

const findLastIndex = (arr, pred) => arr.length - arr.slice().reverse().findIndex(pred) - 1;

export {
  pad0,
  findLastIndex,
};
